
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc4c138f57b0de67a655da9b0f32850b1en from './en.yaml'
            i18n.addResourceBundle('en', 'c4c138f57b0de67a655da9b0f32850b1', flattenObject(nsc4c138f57b0de67a655da9b0f32850b1en), true, true);
        
        export default 'c4c138f57b0de67a655da9b0f32850b1';
    